<template>

    <div>
    <header class="header">
        <nav class="gnav">
            <div class="gnav-inner">
                <p class="gnav-sub-ttl is-first">レイヤー</p>
                <ul class="gnav-layer">
                    <li><a href="#" :class="activateMenu('shape1')" @click.prevent="changeShapeType('shape1')">浸水域</a></li>
                    <li><a href="#" :class="activateMenu('shape2')" @click.prevent="changeShapeType('shape4')">被害等状況</a></li>
                </ul>

                <p class="gnav-sub-ttl">スポット</p>

                <div class="gnav-list-ac">
                    <p class="f-check"><input type="checkbox" id="cb02-00"  v-model="isRenderHinanjoMarker" @click="clickHinanjoCheckBox()"><label for="cb02-00"><span class="icon-f icon-hinanjyo"></span>避難所</label></p>
                </div>

                <div class="gnav-list-ac">
                    <p class="f-check">復旧時被災者支援</p>
                    <div class="ac-item" id="ac-item2" @click="toggleACItem('ac-item2')"></div>
                    <ul>
                        <li v-for="(ele, category) in this.shienMarkerGroup" :key="category">
                            <p class="f-check">
                            <input type="checkbox" :id="category" v-model="ele.status" @click="clickCheckBox(ele)">
                            <label :for="category"><span class="icon-f" :class="getIconClass(category)"></span>{{category}}</label>
                            </p>
                        </li>
                    </ul>
                </div>


                <div class="g-hanrei">
                    <p class="gnav-sub-ttl">浸水域の凡例</p>
                    <ul class="hanrei-list">
<!--                        <li><span class="color-deep-purple"></span>0～0.5ｍ未満</li>-->
<!--                        <li><span class="color-carmine"></span>0.5～1.0ｍ未満</li>-->
<!--                        <li><span class="color-orange"></span>1.0～2.0ｍ未満</li>-->
                        <li><span class="color-carmine"></span>2.0ｍ未満</li>
                        <li><span class="color-deep-purple"></span>2.0ｍ以上</li>
                    </ul>
                </div>

                <div class="g-hanrei">
                    <p class="gnav-sub-ttl">被害等状況の凡例</p>
                    <ul class="hanrei-list">
                        <li><span class="color-canary-yellow"></span>通行止め</li>
                        <li><span class="color-green"></span>片側交互通行</li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="gnav-toggle" id="js-hamburger" @click="toggleMenu()">
            <span class="gnav-toggle-line gnav-toggle-line--1"></span>
            <span class="gnav-toggle-line gnav-toggle-line--2"></span>
            <span class="gnav-toggle-line gnav-toggle-line--3"></span>
            <span class="gnav-txt">メニュー</span>
        </div>

        <div class="header-title">
            <h1>日常生活の質の確保 (※ 表示用のサンプルデータを使用)</h1>
        </div>

        <div class="h-home">
            <a href="/">
                <div class="h-home-inner">
                    <span class="h-home-icon"></span><span class="h-home-txt">ホーム</span>
                </div>
            </a>
        </div>
        <div class="black-bg" id="js-black-bg"></div>
    </header>

    <main class="main">
        <div class="main-inner">
            <!-- Map Area -->
            <div id="map"></div>
            <!-- /Map Area -->
        </div>
    </main>

    </div>
</template>

<script>
    import env from '../../config/env.var'
    import L from 'leaflet'
    import * as turf from "@turf/turf"
    export default {
        name: "mapE",
        components:{},
        data () {
            return{
                map: null,
                radius: 500, // meter
                markerGroup: null,
                mapCircle: null,
                tfCircle: null,
                shuhenMarkerGroup: {},
                shienMarkerGroup: {},
                hisaishaShienGroup: {},
                isRenderHinanjoMarker: true,
                isRenderShuuhenMarker: true,
                isRenderShienMarker: true,
            }
        },
        mounted () {
            this.drawMap()
            Promise.all([this.getShape(), this.getCsv()])
            .then(() => {
                this.renderShape()
            })

            // 避難所
            Promise.all([this.getCsvHinanjo()])
            .then(() => {
                this.renderHinanjo();
            });

            // 被災者支援
            Promise.all([this.getCsvHisaishaShien()])
            .then(() => {
                this.renderHisaishaShien();
            });

        },
        computed: {
            sharedState () {
                return this.$store.state
            },
            shape_type () {
                return this.sharedState.shape_type
            }
        },
        methods: {
            toggleMenu() {
                const body = document.body;
                body.classList.toggle('nav-open');
            },
            activateMenu(shapeType) {
              return this.sharedState.shape_type === shapeType ? 'is-active': ''
            },
            toggleACItem(acId) {

                let acItem = $('#'+acId)

                if (acItem.hasClass('is-active')) {
                    acItem.removeClass('is-active');
                    acItem.next()
                    .stop()
                    .slideUp(300);
                } else {
                    acItem.addClass('is-active');
                    acItem.next()
                    .stop()
                    .slideDown(300);
                }
            },
            getIconClass(category) {
                console.log('eee')
              return env.markerCategory2CssClass[category]
            },
            drawMap () {
                // タイルの設定
                const osmtile = L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors'
                })
                const gsistdtile = L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>"
                })
                const pale = L.tileLayer('//cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: '&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target=\'_blank\'>地理院タイル</a>'
                })
                // マップの初期化
                const map = L.map('map', {
                    center: [34.633626, 133.710630],
                    zoom: 14,
                    layers: [pale],
                    zoomControl: false,
                    minZoom: 6,
                    maxZoom: 17,
                    gestureHandling: true,
                    preferCanvas: true,
                    scrollWheelZoom: false
                })
                L.control.zoom({ position: 'bottomright' }).addTo(map)
                const mapObj = document.getElementById('map')
                // フォーカスしたらズームできるようになる
                mapObj.addEventListener("focus", () => {map.scrollWheelZoom.enable()});
                // フォーカスはずれたらズームできなくする
                mapObj.addEventListener("blur", () => {map.scrollWheelZoom.disable()});
                // clickされたポイントを中心に円を描画
                // map.on('click', (e) => {this.centerPointClick(e)});

                // デバッグ用に縮尺表示
                L.control.scale({imperial:false}).addTo(map)

                L.control.layers({
                  "OpenStreetMap": osmtile,
                  "国土地理院 - 淡色": pale,
                  "国土地理院 - 標準地図": gsistdtile,
                }).addTo(map)

                this.map = map
                this.$store.commit('setMap', map)
            },
            centerPointClick (event) {
                let LatLng = [event.latlng.lat, event.latlng.lng]

                // 経度緯度(逆なのに注意)
                const LngLat = [event.latlng.lng, event.latlng.lat]

                // 既存の円の内部をクリックした場合は円の削除処理のみを行い処理をスキップ
                if (this.tfCircle && turf.booleanPointInPolygon(LngLat, this.tfCircle)) {
                    this.mapCircle.removeFrom(this.map)
                    this.tfCircle = null

                    return
                }

                if (!!this.mapCircle) {// eslint-disable-line
                    this.mapCircle.removeFrom(this.map)
                    this.tfCircle = null
                }

                // 範囲指定用の円を作成（turfの機能）
                let searchWithin = this.createCircle(LatLng, this.radius)// eslint-disable-line
            },
            serchWithinCircle (markerDataset, polygon) {
                // polygonの範囲内のmarkerDataのみ抽出して配列に追加
                var markerWithin = []
                for (let markerData of markerDataset) {
                    let LatLng = markerData.LatLng
                    let pt = [LatLng[1], LatLng[0]]
                    if (turf.booleanPointInPolygon(pt, polygon)) {
                        markerWithin.push(markerData)
                    }
                }

                return markerWithin
            },
            createCircle (LatLng, radius) {
                let radius_km = radius/1000
                // turf uses LngLat order
                const LngLat = [LatLng[1], LatLng[0]]
                const tf_options = {steps: 50, units: 'kilometers'}
                const tf_circle = turf.circle(LngLat, radius_km, tf_options)


                this.mapCircle = L.geoJSON(tf_circle).addTo(this.map)
                this.tfCircle = tf_circle

                return tf_circle
            },
            async removeLayer (shape_type) {
                await this.$store.commit('removeLayer', this.sharedState.layers[shape_type])
            },
            setColor (features) {
                // csvのデータからshapeの色分け
                // const KEY_CODE = features.properties.KEY_CODE
                // let popLevel = 0;
                // const info = this.sharedState.csv[this.sharedState.shape_type][KEY_CODE]
                // if (info) {
                //     for (const level in env.THRESHOLD) {
                //         if (info.value >= env.THRESHOLD[level].value) popLevel = level
                //     }
                // }
                // return env.THRESHOLD[popLevel].color
                switch (this.sharedState.shape_type) {
                    case 'shape1':
                        return env.THRESHOLD[features.properties.A31_001]
                    case 'shape2':
                        return env.DOSYA_KEIKAI
                    case 'shape3':
                        return env.DOSYA_KIKEN
                    default:
                        return env.THRESHOLD[features.properties.A31_001]
                }

            },
            async getShape () {
                await this.$store.dispatch('getShape')
            },
            async getCsv () {
                await this.$store.dispatch('getCsv')
            },
            async getCsvHinanjo() {
                await this.$store.dispatch('getCsvHinanjo')
            },
            async getCsvHisaishaShien() {
                await this.$store.dispatch('getCsvHisaishaShien')
            },
            setShapePopup (features, layer) {
                switch (this.shape_type) {
                    case 'shape1':
                        // 浸水域は不明なのでポップアップなし
                        break;
                    case 'shape4':
                        //被害状況等は線がクリックできる範囲が狭すぎるのでポップアップはしない
                        layer.bindPopup(features.properties.id == '1' ? '通行止め' : '片側通行止め')
                        break;
                }
            },
            async getSyuuhenMarkers () {
                await this.$store.dispatch('getSyuuhenMarkers')
            },
            renderShape () {
                // var prevLayerClicked = null;
                const geo = L.geoJSON(this.sharedState.shape[this.sharedState.shape_type], {
                    style:(features) => {
                        // console.log(features) //eslint-disable-line

                        // 浸水被害のshapeは14,15以外は表示しない暫定対応とする。
                        // ※ 浸水想定と実際の被害がほぼ一致するため。

                        if (this.sharedState.shape_type == 'shape1' &&
                            features.properties.A31_001 < 14) {

                            return {
                                color: 'none',
                            }
                        }

                        if (this.sharedState.shape_type == 'shape4') {

                            console.log(features.properties)

                            return {
                                fillColor: this.setColor(features),
                                color: features.properties.id == '1' ? '#fff262' : '#008000',
                                weight: 9.0,
                            }
                        }

                        return {
                            fillColor: this.setColor(features),
                            color: 'grey',
                            // color: '#00a795',
                            weight: 0.5,
                        }
                    },
                    getColor:(d) => {
                        return d < 1 ? '#173e34' : '#e1cb7f';
                    },
                    onEachFeature: (features, layer) => {
                        // const KEY_CODE = features.properties.KEY_CODE
                        // const info = this.sharedState.csv[this.sharedState.shape_type][KEY_CODE]
                        // console.log(features)  //eslint-disable-line

                        const DEFAULT_BORDER_STYLE = {
                            color: 'grey',
                            weight: 0.5,
                        }

                        const FOCUSED_BORDER_STYLE = {
                            color: 'red',
                            weight: 1.5,
                        }

                        // shapeのクリック
                        this.setShapePopup(features, layer)

                        // 被害状況の場合はshapeが線なので色を変更するようなイベントは発火させない
                        if (this.sharedState.shape_type == 'shape4') {
                            return
                        }

                        layer.on({
                                mouseover: function()
                                {
                                    if( ! layer.isPopupOpen()){
                                        layer.setStyle(FOCUSED_BORDER_STYLE)
                                    }
                                },
                                mouseout: () =>
                                {
                                    if( ! layer.isPopupOpen()){
                                        layer.setStyle(DEFAULT_BORDER_STYLE)
                                    }
                                },
                                popupopen: function()
                                {
                                    layer.setStyle(FOCUSED_BORDER_STYLE)
                                },
                                popupclose: function()
                                {
                                    layer.setStyle(DEFAULT_BORDER_STYLE)
                                }

                            })
                    },
                    renderer: L.svg()
                })
                this.$store.commit('addLayer', geo)

            },
            changeShapeType (shape_type) {
                this.$store.commit('setShapeType', shape_type)
            },
            changeShape (newval, oldval) {
                if (this.sharedState.layers[newval] == null) {
                    Promise.all([this.getShape(), this.getCsv()])
                    .then(() => {
                        this.removeLayer(oldval)
                        this.renderShape()
                    })
                } else {
                    this.removeLayer(oldval)
                    this.renderShape()
                }
            },
            renderHinanjo(){

                let markerGroup = []

                const iconUrl = env.markerCategory2Img['避難所']

                for(let i = 0; i < this.sharedState.hinanjoList.length; i++){

                    const marker = this.sharedState.hinanjoList[i]

                    const disasters = [
                        '災害種別_洪水',
                        '災害種別_崖崩れ、土石流及び地滑り',
                        '災害種別_高潮',
                        '災害種別_地震',
                        '災害種別_津波',
                        '災害種別_大規模な火事',
                        '災害種別_内水氾濫',
                        '災害種別_火山現象',
                    ]

                    let targetDisasters = []

                    disasters.forEach(disaster => {
                        if (marker[disaster] == '1') {

                            const titles = disaster.split('_')
                            targetDisasters.push(titles[1])
                        }
                    })

                    var popup1 = L.popup({
                      keepInView : true,
                      minWidth : 500,
                      autoPanPadding: L.point(0, 70) // ヘッダーメニューの高さ分paddingを設定
                    }).setContent(
                      "<h1 class='modal-title pb-xs'>"+marker['名称']+"</h1>"+
                      "<div class='pb-sm'>"+
                      "<dl class='dl-list is-modal'>"+"<dt>所在地</dt>"+"<dd>"+marker['住所']+"</dd>"+"</dl>"+
                      "<dl class='dl-list is-modal'>"+"<dt>災害種別</dt>"+"<dd>"+targetDisasters.join(',')+"</dd>"+"</dl>"+
                      "<dl class='dl-list is-modal'>"+"<dt>想定収容人数</dt>"+"<dd>"+marker['想定収容人数']+"人</dd>"+"</dl>"+
                      "<dl class='dl-list is-modal'>"+"<dt>開設状況</dt>"+"<dd>"+(marker['開設状況'] == '1' ? '開設中' : '閉設中' )+"</dd>"+"</dl>"+
                      "</div>"+
                      "<div class='popup-btn'><a class='c-btn c-btn-default c-btn-md' target='_blank' href='https://maps.google.com/maps?saddr=現在地&daddr="+ marker['緯度']+','+marker['経度'] +"'>行き方を調べる(GoogleMapが開きます)</a></div>"

                    );

                    var markerIcon = L.icon({ iconUrl: iconUrl, iconRetinaUrl: iconUrl, iconSize: [35, 35], iconAnchor: [17, 17], popupAnchor: [0, -50] });
                    const mark = L.marker([marker['緯度'], marker['経度']], { icon:markerIcon, zIndexOffset: 300}, { draggable: false }).bindPopup(popup1).bindTooltip(marker['名称']);
                    // this.$store.commit('addMarker', mark)
                    this.$store.commit('addMarker', mark)


                    markerGroup.push(mark)
                }

                this.markerGroup = L.layerGroup(markerGroup).addTo(this.map)
            },
            renderHisaishaShien(){

                let markers = {}

                for(var i = 0; i < this.sharedState.hisaishaShienList.length; i++){

                    const line = this.sharedState.hisaishaShienList[i]
                    const category = line['項目']

                    var popup1 = L.popup({
                        keepInView : true,
                        minWidth : 500,
                        autoPanPadding: L.point(0, 70) // ヘッダーメニューの高さ分paddingを設定
                    }).setContent(
                      "<h1 class='modal-title pb-xs'>"+line['項目']+"</h1>"+
                      "<div class='pb-sm'>"+
                      "<dl class='dl-list is-modal'>"+"<dt>支援場所名称</dt>"+"<dd>"+line['支援場所名称']+"</dd>"+"</dl>"+
                      "<dl class='dl-list is-modal'>"+"<dt>お問い合わせ先</dt>"+"<dd>"+line['お問い合わせ先']+"</dd>"+"</dl>"+
                      "<dl class='dl-list is-modal'><dt>詳細</dt><dd>"+line['内容']+"</dd></dl>"+
                      "</div>"
                    );
                    var iconUrl = env.markerCategory2Img[line['項目']]
                    var markerIcon = L.icon({ iconUrl: iconUrl, iconRetinaUrl: iconUrl, iconSize: [35, 35], iconAnchor: [17, 17], popupAnchor: [0, -50] });
                    const marker = L.marker([line['緯度'],line['経度']], { icon:markerIcon, zIndexOffset: 1000 }, { draggable: false }).bindPopup(popup1).bindTooltip(line['項目']);
                    // this.$store.commit('addMarker', marker)

                    if (!(category in markers)) {
                        markers[category] = [marker]
                    } else {
                        markers[category].push(marker)
                    }
                }
                for (let c in markers) {
                    this.$set(this.shienMarkerGroup, c, { status: true, layer: L.layerGroup(markers[c]).addTo(this.map)})
                }
            },
            clickCheckBox(ele) {
                if (!ele.status) {
                    this.$store.commit('addMarker', ele.layer)
                } else {
                    this.$store.commit('removeMarker', ele.layer)
                }
            },
            clickHinanjoCheckBox() {
                if (!this.isRenderHinanjoMarker) {
                    this.$store.commit('addMarker', this.markerGroup)
                } else {
                    this.$store.commit('removeMarker', this.markerGroup)
                }
            },
            clickShuuhenCheckBox() {
                if (!this.isRenderShuuhenMarker) {
                    for (let category in this.shuhenMarkerGroup) {
                        let marker = this.shuhenMarkerGroup[category]
                        marker.status = true
                        this.$store.commit('addMarker', marker.layer)
                    }
                } else {
                    for (let category in this.shuhenMarkerGroup) {
                        let marker = this.shuhenMarkerGroup[category]
                        marker.status = false
                        this.$store.commit('removeMarker', marker.layer)
                    }
                }
            },
            clickShienCheckBox() {
                if ( ! this.isRenderShienMarker) {
                    for (let category in this.shie) {
                        let marker = this.shienMarkerGroup[category]
                        marker.status = true
                        this.$store.commit('addMarker', marker.layer)
                    }
                } else {
                    for (let category in this.shienMarkerGroup) {
                        let marker = this.shienMarkerGroup[category]
                        marker.status = false
                        this.$store.commit('removeMarker', marker.layer)
                    }
                }
            }
        },
        watch: {
            shape_type: function(newval, oldval) {
                this.changeShape(newval, oldval)
            },
        }
    }
</script>

<style>

/*
 * Leafletのレイヤーコントロールの位置調整
 * 参考 https://github.com/Leaflet/Leaflet/issues/4021
 */

.leaflet-control-container {
    display: block;
}

.leaflet-control-layers {
    left: 0px;
    top: 60px;
}

.leaflet-touch .leaflet-control-attribution {
    display: none;
}
</style>
